import { useSelector } from 'react-redux';

export const useTotalUnrealizedProfitLossForSide = (instrumentId, side) => {
  const positionsUnrealizedProfitLoss = useSelector((state) => state.currencies.positionsUnrealizedProfitLoss);
  return Object.values(positionsUnrealizedProfitLoss[instrumentId])
    .filter(({ side: positionSide }) => positionSide === side)
    .reduce((accumulator, { unrealizedProfitLoss }) => accumulator + unrealizedProfitLoss, 0);
};
